// Centraal configuratiebestand voor betaaltarieven (pas hier aan, niet in de pagina's).
export const FEES = {
  ideal: {
    label: "iDEAL",
    rows: [
      ["Transactiekosten", "€0,32 per betaling"],
      ["Terugbetaling", "€0,25"],
    ],
  },
  card: {
    label: "Creditcard en debitcard",
    rows: [
      ["Europese consumentenkaart", "€0,25 + 1,8%"],
      ["Zakelijke of niet-EU-kaart", "€0,25 + 3,25%"],
      ["Zakelijke kaart binnen de EER", "€0,25 + 2,9%"],
      ["Terugbetaling", "volgens actuele Mollie-kosten"],
      ["Chargebackkosten", "kunnen van toepassing zijn"],
    ],
  },
  paypal: {
    label: "PayPal",
    rows: [
      ["VRIJMARKT/Mollie-verwerkingskosten", "€0,10 + de kosten die PayPal zelf rekent"],
      ["PayPal Capture", "€0,10"],
      ["Terugbetaling", "€0,25"],
      ["Chargeback", "€25,00"],
    ],
  },
};

export const FEES_DISCLAIMER =
  "Betaaltarieven kunnen door Mollie, PayPal, banken of kaartmaatschappijen worden gewijzigd. De definitieve kosten die tijdens het afrekenen worden getoond zijn leidend.";
